import React from 'react'
import { FieldWrapper, Label, Select, Input, RemoveButton } from './Components'
import { LeftArrowIcon } from 'components_v2/Icons'

const SectionItem = ({
  itemIndex,
  item,
  setFieldValue,
  getClassListbyPlan,
  seriesItems,
  itemList,
  bonusItems,
  sectionIndex,
  remove,
  moveSectionIndex,
  errors,
  length
}) => {
  return (
    <div className='section-item'>
      <div key={itemIndex} className='align-items-center'>
        <FieldWrapper>
          <Label>Type</Label>
          <Select
            value={item.type}
            name={`sections[${sectionIndex}].items[${itemIndex}].type`}
            onChange={(e) => {
              const { value } = e.target
              setFieldValue(
                `sections[${sectionIndex}].items[${itemIndex}].type`,
                value
              )
              if (value !== 'class_from_another_series') {
                setFieldValue(
                  `sections[${sectionIndex}].items[${itemIndex}].series`,
                  ''
                )
              }
              setFieldValue(
                `sections[${sectionIndex}].items[${itemIndex}].id`,
                ''
              )
            }}
          >
            <option value='class'>Class</option>
            <option value='class_from_another_series'>
              Class from another series
            </option>
            {bonusItems.length > 0 && <option value='bonus'>Bonus</option>}
          </Select>
        </FieldWrapper>
        {item.type === 'class_from_another_series' && (
          <FieldWrapper>
            <Label>Series</Label>
            <Select
              value={item.series}
              name={`sections[${sectionIndex}].items[${itemIndex}].series`}
              onChange={(e) => {
                const { value } = e.target
                setFieldValue(
                  `sections[${sectionIndex}].items[${itemIndex}].series`,
                  value
                )
                setFieldValue(
                  `sections[${sectionIndex}].items[${itemIndex}].id`,
                  ''
                )
                getClassListbyPlan(value)
              }}
            >
              <option value='' disabled>
                Select a Series
              </option>
              {seriesItems.map((series) => (
                <option key={series.id} value={series.id}>
                  {series.title}
                </option>
              ))}
            </Select>
          </FieldWrapper>
        )}
        <FieldWrapper>
          <Label>
            {item.type === 'bonus'
              ? 'Bonus Item'
              : item.type === 'series'
              ? 'Series'
              : 'Class'}
          </Label>
          <Select
            value={item.id}
            name={`sections[${sectionIndex}].items[${itemIndex}].id`}
            onChange={(e) => {
              const { value } = e.target
              setFieldValue(
                `sections[${sectionIndex}].items[${itemIndex}].id`,
                value
              )
            }}
            disabled={
              (item.type === 'class_from_another_series' && !item.series) ||
              !(itemList.length > 0)
            }
          >
            <option value='' disabled>
              Select a{' '}
              {item.type === 'bonus'
                ? 'Bonus Item'
                : item.type === 'series'
                ? 'Series'
                : 'Class'}
            </option>
            {itemList.map((option) => (
              <option key={option.id} value={option.id}>
                {option.title}
              </option>
            ))}
          </Select>
          {errors?.sections?.[sectionIndex]?.items?.[itemIndex]?.id && (
            <div className='text-danger'>
              Item is required
              {item.type === 'class_from_another_series' &&
                !item.series &&
                ` (Pick a series to enable)`}
            </div>
          )}
        </FieldWrapper>
      </div>
      <div className='align-items-center'>
        <FieldWrapper>
          <Label>Tag</Label>
          <Input
            name={`sections[${sectionIndex}].items[${itemIndex}].itemTag`}
            placeholder='Item Tag'
          />
        </FieldWrapper>

        <FieldWrapper>
          <Label>Description</Label>
          <Input
            name={`sections[${sectionIndex}].items[${itemIndex}].description`}
            placeholder='Item Description'
          />
        </FieldWrapper>
      </div>
      <div className='section-item-actions remove-item'>
        <RemoveButton
          type='button'
          className='btn btn-danger'
          onClick={() => remove(itemIndex)}
        >
          Remove Item
        </RemoveButton>
        {length && length > 1 && (
          <>
            <button
              className='btn btn-success up'
              disabled={itemIndex === 0}
              onClick={(e) => {
                e.preventDefault()
                moveSectionIndex(itemIndex, itemIndex - 1)
              }}
            >
              Move Up <LeftArrowIcon />
            </button>
            <button
              disabled={itemIndex === length - 1}
              className='btn btn-success down'
              onClick={(e) => {
                e.preventDefault()
                moveSectionIndex(itemIndex, itemIndex + 1)
              }}
            >
              Move Down <LeftArrowIcon />
            </button>
            <FieldWrapper className='move-field'>
              <Label>Move to</Label>
              <Select
                name={`sections[${sectionIndex}].items[${itemIndex}].series`}
                onChange={(e) => {
                  const { value } = e.target
                  moveSectionIndex(itemIndex, value)
                }}
                value={itemIndex}
              >
                {Array.from({ length }, (_, index) => (
                  <option key={index} value={index}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </FieldWrapper>
          </>
        )}
      </div>
    </div>
  )
}

export default SectionItem
